export default {
  title: 'Apps',
  fields: {
    id: 'ID',
    name: 'Nombre',
    app_bundle_identifier: 'ID del paquete de app',
    released: 'Publicada',
    franchise: 'Marca',
    app_icon: 'Ícono de app',
    status: 'Estado',
    play_store_link: 'Enlace de Play Store',
    apple_store_link: 'Enlace de Apple Store',
    dynamic_link: 'Enlace dinámico - Códigos QR',
  },
  filters: {
    name: 'Nombre',
    released: 'Publicada',
  },
  columns: {
    backlog: '📋 Backlog',
    ready_to_build: '🛠️ Listo para crear',
    in_work: '🔧 En progreso',
    in_review: '📝 En revisión',
    rejected: '❌ Rechazada',
    released: '✅ Publicada',
    deactivated: '🛑 Desactivada',
  },
  card: {
    overdue: 'Atrasada · {{time}}',
    copied: 'Copiado al portapapeles',
    released_tag: {
      both: '✅ Publicada',
      ios: 'iOS publicada',
      android: 'Android publicada',
    },
    tags: {
      has_tech_issue: 'Problema técnico',
    },
  },
  status_modal: {
    title: 'Actualizar estado de publicación',
    status_label: 'Estado',
    note_label: 'Nota (opcional)',
    note_placeholder: 'Añade una nota opcional para este cambio de estado',
    tech_issue_checkbox: 'Hay un problema técnico',
    save: 'Guardar',
    cancel: 'Cancelar',
  },
  released: {
    yes: 'Sí',
    no: 'No',
  },
  configured_status: {
    true: 'Sí',
    false: 'No',
  },
  delete_confirmation: {
    title: 'Eliminar app móvil',
    message: '¿Seguro que desea eliminar esta app móvil?',
    buttons: {
      confirm: 'Confirmar',
      cancel: 'Cancelar',
    },
  },
};
